import * as React from 'react';
import {PluginTemplates} from "../../../../utils/PluginTemplates";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import {authorize, IWithRouterProps, withRouter} from "@athena-portal/components";
import {getSessionStorage} from "../../../../CommonFunctions";
import {CardForm} from "../../../../components/payments/CardForm";
import {
    FalconPaymentRequest,
    NewCardForm,
    ProductsEnum,
} from "@ferry/journey-services";
import {FalconNavigatorHeader, Footer} from "@ferry/portal-core";
import {lazyInject} from "@athena-portal/core";
import {Types} from "../../../../Types";
import type {ICustomerPortalService} from "../../../../services/ICustomerPortalService";

interface IParams {
    policyNumber: string;
    [key: string]: string | undefined
}

interface IState {
    settings: any,
    newCardForm?: NewCardForm
}

@authorize
export class NewCardPaymentPagePlain extends React.Component<IWithRouterProps<IParams>, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    private pluginTemplates = new PluginTemplates();

    constructor(props: IWithRouterProps<IParams>) {
        super(props);
        this.state = {
            settings: getSessionStorage("paymentSettings")
        };
    }

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("New card payment");
        const policyNumber = this.props.params.policyNumber;

        const request: FalconPaymentRequest = new FalconPaymentRequest();
        request.invoiceType = this.state.settings.invoiceType;
        request.product = ProductsEnum.WOLF_MOTOR;

        this.customerPortalService.authorizeNewCard(request, policyNumber).subscribe((newCardForm: NewCardForm) => {
            this.setState({newCardForm})
        });
    }

    public render() {
        const returnUrl = this.state.settings?.returnUrl || "/dashboard";
        const description = this.state.settings?.description || "Payment";
        return (
            <React.Fragment>
                <FalconHeader/>
                <div className="plugin">
                    <FalconNavigatorHeader back={returnUrl} title={description}/>
                    <CardForm newCardForm={this.state.newCardForm}
                              verifyNewCardFailed={this.props.location.state?.verifyCardFailed}
                              policyNumber={this.props.params.policyNumber}/>
                    {this.pluginTemplates.renderBackReloadLink("Back", false, returnUrl)}
                </div>
                <Footer/>
            </React.Fragment>
        )
    }
}

export const NewCardPaymentPage = withRouter<{}, IParams>(NewCardPaymentPagePlain)
